import Request from '@/api/request';

const api = new Request('lk/fs/');

export interface IFileData {
  link: string;
  md5: string;
  name: string;
}

interface ISigFileRequest {
  sigBas64: string;
  fileName: string;
}

export function saveFile(file: Blob): Promise<IFileData> {
  const formData = new FormData();

  formData.append('file', file);

  return api.post('saveFile', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function deleteFile(link: string) {
  return api.delete(`deleteFile/${link}`);
}

export function getFileLink(link: string) {
  return `/api/lk/fs/downloadFile/${link}`;
}

// Подписание файла на всех шагах (не xml)
export function saveSigFile(data: ISigFileRequest): Promise<IFileData> {
  return api.post('saveSigFile', data);
}
